import { render, staticRenderFns } from "./CommodityFlowAdjustmentEdit.vue?vue&type=template&id=1d66ae3c&scoped=true&"
import script from "./CommodityFlowAdjustmentEdit.vue?vue&type=script&lang=js&"
export * from "./CommodityFlowAdjustmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66ae3c",
  null
  
)

export default component.exports